var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30.956px",
    height: "30.956px",
    fill: "#009688",
    viewBox: "0 0 30.956 30.956",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-481.972 -322.633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.039,324.633a1.891,1.891,0,0,1,1.889,1.89V349.7a1.891,1.891,0,0,1-1.889,1.89H485.862a1.892,1.892,0,0,1-1.89-1.89V326.523a1.892,1.892,0,0,1,1.89-1.89h23.177m0-2H485.862a3.89,3.89,0,0,0-3.89,3.89V349.7a3.89,3.89,0,0,0,3.89,3.89h23.177a3.889,3.889,0,0,0,3.889-3.89V326.523a3.889,3.889,0,0,0-3.889-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.105,332.478H489.523a1,1,0,1,1,0-2h15.582a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.105,339.188H489.523a1,1,0,1,1,0-2h15.582a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.105,345.9H489.523a1,1,0,0,1,0-2h15.582a1,1,0,0,1,0,2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.f385e526051b1f1559c381012d090a83.svg";
export { ForwardRef as ReactComponent };